<div mat-dialog-title>
  <span>{{ data.title }}</span
  ><br />
  <span class="small-text">{{ data.message }}</span>
  <div class="filter-wrapper">
    <mat-form-field appearance="outline">
      <input matInput placeholder="Filter" [(ngModel)]="filterText" />
    </mat-form-field>
  </div>
</div>
<div mat-dialog-content class="list-wrapper">
  <mat-selection-list [multiple]="false">
    <mat-list-option
      *ngFor="let item of getFilteredItems()"
      [value]="item"
      (click)="onItemClicked(item)"
    >
      {{ item.description }}
    </mat-list-option>
  </mat-selection-list>
</div>

<div mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial (click)="onCancelClick()">
    Cancel
  </button>
  <button
    mat-button
    mat-dialog-close
    (click)="onOkClicked()"
    [disabled]="!selectedItem"
  >
    Ok
  </button>
</div>
